var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"message-transition"}},[(!_vm.valid)?_c('div',{staticClass:"error--text v-messages"},_vm._l((_vm.errorMessages),function(message,i){return _c('div',{key:i},[_vm._v(" "+_vm._s(message)+" ")])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }